"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemStorage = void 0;
/**
 * The memory storage implementation.
 * @category Utilities
 */
class MemStorage {
    constructor() {
        this.mem = {};
    }
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mem[key];
        });
    }
    set(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.mem[key] = value;
            ;
        });
    }
    delete(key) {
        return __awaiter(this, void 0, void 0, function* () {
            delete this.mem[key];
        });
    }
    listKeys() {
        return __awaiter(this, void 0, void 0, function* () {
            return Object.keys(this.mem);
        });
    }
    listMetadata() {
        return __awaiter(this, void 0, void 0, function* () {
            return Object.values(this.mem).map(ele => {
                return { metadata: ele.metadata };
            });
        });
    }
}
exports.MemStorage = MemStorage;
